module.exports = __webpack_public_path__ + "static/media/Mississippi_FullWhite.88185dd9.svg";